export const getRecaptchaId = (formName) => {
  const configObj = formConfig[formName]
  if (!configObj) {
    return null
  }
  return `recaptcha_${configObj.inf_form_xid}`
}

const formConfig = {
  test: {
    action:
      'https://wo246.infusionsoft.com/app/form/process/c612f05dbec6e61322cafca5186b5b70',
    formId: 'inf_form_c612f05dbec6e61322cafca5186b5b70',
    inf_form_xid: 'c612f05dbec6e61322cafca5186b5b70',
    inf_form_name: 'Web Form submitted',
    infusionsoft_version: '1.70.0.77019',
  },
  tenThings: {
    action:
      'https://wo246.infusionsoft.com/app/form/process/fd728998b73bee0d818f2c66ef35deac',
    formId: 'inf_form_fd728998b73bee0d818f2c66ef35deac',
    inf_form_xid: 'fd728998b73bee0d818f2c66ef35deac',
    inf_form_name: 'Website Homepage&#a;Free Report Request',
    infusionsoft_version: '1.70.0.76272',
  },
  requestAppointment: {
    action:
      'https://wo246.infusionsoft.com/app/form/process/bfd6aabbc02cf43c8cc90b0a568c1535',
    formId: 'inf_form_bfd6aabbc02cf43c8cc90b0a568c1535',
    inf_form_xid: 'bfd6aabbc02cf43c8cc90b0a568c1535',
    inf_form_name: 'Web Form submitted',
    infusionsoft_version: '1.70.0.158799',
  },
  mayoPhysicians: {
    action:
      'https://wo246.infusionsoft.com/app/form/process/8617f980876b3fc06d8ec9d4f7519ded',
    formId: 'inf_form_8617f980876b3fc06d8ec9d4f7519ded',
    inf_form_xid: '8617f980876b3fc06d8ec9d4f7519ded',
    inf_form_name: 'Physicians',
    infusionsoft_version: '1.70.0.76272',
  },
  mayoResidents: {
    action:
      'https://wo246.infusionsoft.com/app/form/process/ddfe774887ee33c95c59d91a8283d547',
    formId: 'inf_form_ddfe774887ee33c95c59d91a8283d547',
    inf_form_xid: 'ddfe774887ee33c95c59d91a8283d547',
    inf_form_name: 'Allied Staff',
    infusionsoft_version: '1.70.0.76272',
  },
  invisalignFiveThings: {
    action:
      'https://wo246.infusionsoft.com/app/form/process/db94df5cc26343aa05cd1b3762fda94c',
    formId: 'inf_form_db94df5cc26343aa05cd1b3762fda94c',
    inf_form_xid: 'db94df5cc26343aa05cd1b3762fda94c',
    inf_form_name: 'Invisalign Opt-In',
    infusionsoft_version: '1.70.0.76272',
  },
  freeBook: {
    action:
      'https://wo246.infusionsoft.com/app/form/process/cf20298576b35cb09e80c68ccf0d4ed7',
    formId: 'inf_form_cf20298576b35cb09e80c68ccf0d4ed7',
    inf_form_xid: 'cf20298576b35cb09e80c68ccf0d4ed7',
    inf_form_name: 'eBook Ordered&#a;TheBracesBook.com',
    infusionsoft_version: '1.70.0.76272',
  },
  orthodonticReferral: {
    action:
      'https://wo246.infusionsoft.com/app/form/process/ab5a4b7ca9cc2d73e4360b649d87fe32',
    formId: 'inf_form_ab5a4b7ca9cc2d73e4360b649d87fe32',
    inf_form_xid: 'ab5a4b7ca9cc2d73e4360b649d87fe32',
    inf_form_name: 'Web Form submitted',
    infusionsoft_version: '1.70.0.78606',
  },
  referAFriend: {
    action:
      'https://wo246.infusionsoft.com/app/form/process/9a390b437a161aeb17f4d818099f7cdd',
    formId: 'inf_form_9a390b437a161aeb17f4d818099f7cdd',
    inf_form_xid: '9a390b437a161aeb17f4d818099f7cdd',
    inf_form_name: 'Refer a friend form submission',
    infusionsoft_version: '1.70.0.503005',
  },
}

export default formConfig
